import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import styles from './truncated-text.module.scss';

const CHARS_PER_LINE = 45;

export default class TruncatedText extends Component {
  @service intl;

  @tracked isExpanded = false;
  @tracked showToggle = false;

  constructor() {
    super(...arguments);
    this.checkTruncation();
  }

  checkTruncation() {
    const text = this.args.text ?? '';
    const newlineCount = (text.match(/\n/g) || []).length;
    const maxCharsForThreeLines = CHARS_PER_LINE * 3;
    const effectiveCharCount = text.length + newlineCount * CHARS_PER_LINE;
    const needsTruncation = effectiveCharCount > maxCharsForThreeLines;

    this.showToggle = needsTruncation;
  }

  get buttonText() {
    return this.isExpanded
      ? this.intl.t('emc.truncated_text.show_less')
      : this.intl.t('emc.truncated_text.show_more');
  }

  get textClasses() {
    let isTruncated = this.showToggle && !this.isExpanded;
    return `text ${isTruncated ? 'truncated' : ''}`;
  }

  get toggleContainerClasses() {
    return `toggle-container ${this.isExpanded ? 'expanded' : ''}`;
  }

  @action
  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }

  <template>
    <div class="{{styles.component}} truncated-text" data-test-truncated-text>
      <div class="container" data-test-container>
        <div class={{this.textClasses}} data-test-text-content>
          {{@text}}
        </div>
      </div>
      {{#if this.showToggle}}
        <div class={{this.toggleContainerClasses}} data-test-toggle-container>
          <button
            class="toggle-button"
            type="button"
            {{on "click" this.toggleExpanded}}
            data-test-toggle-button
          >
            {{this.buttonText}}
          </button>
        </div>
      {{/if}}
    </div>
  </template>
}
